import { Tag } from 'antd';
import { statusColorMap } from './constants';
import type { IWhTaskStatusTagProps } from './types';

export const WhTaskStatusTag = (props: IWhTaskStatusTagProps) => {
  const { status } = props;

  return <Tag color={statusColorMap[status]}>{status}</Tag>;
};
